// extracted by mini-css-extract-plugin
module.exports = {"container":"Vision_container__3HT4Z"};